<div *ngIf="question && debugMode">
  <div class="row">
    <div class="col-8"></div>
  </div>
</div>
